export const FEATURES = [
  {
    title: 'Personal Guidance',
    desc: 'Kundli analysis and remedies for career, health, marriage and money.',
    path: 'M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z',
  },
  {
    title: 'Astrology Classes',
    desc: 'Learn Vedic astrology, palmistry and Vastu through live online courses.',
    path: 'M21.42 10.922a1 1 0 0 0-.019-1.838L12.83 5.18a2 2 0 0 0-1.66 0L2.6 9.08a1 1 0 0 0 0 1.832l8.57 3.908a2 2 0 0 0 1.66 0z',
    extraPaths: ['M22 10v6', 'M6 12.5V16a6 3 0 0 0 12 0v-3.5'],
  },
  {
    title: 'Sacred Products',
    desc: 'Genuine gemstones, Rudraksha and Yantras, energised by Maharaj Ji.',
    path: 'M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z',
    extraPaths: ['M3 6h18', 'M16 10a4 4 0 0 1-8 0'],
  },
]
